import { render, staticRenderFns } from "./VsViewUpload.vue?vue&type=template&id=fda5540e&"
import script from "./VsViewUpload.vue?vue&type=script&lang=js&"
export * from "./VsViewUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports